module.exports = __webpack_public_path__ + "static/img/dull_oily-01.a5dba57.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/dull_oily-01.jpg
// module id = 264
// module chunks = 1